import { useState, useEffect } from 'react';

const API_URL = "https://facach.coop.hn/api";
const CMS_URL = "https://facach.coop.hn";

const buildImgUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${CMS_URL}${path}`;
};

export function useCommittee(code) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) return;
    const fetch_ = async () => {
      try {
        const res  = await fetch(`${API_URL}/committees/${code}`);
        const json = await res.json();
        if (json.ok) setData(json.data);
      } catch (err) {
        console.error(`Error cargando comité ${code}:`, err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, [code]);

  return { data, loading };
}
